export default __webpack_public_path__ + "static/astral-1d2d7ef4a4ac189de8eb867005e41cf7.gif";